import { render, staticRenderFns } from "./m-menu.vue?vue&type=template&id=ebcb8ac8&scoped=true&"
import script from "./m-menu.vue?vue&type=script&lang=ts&setup=true&"
export * from "./m-menu.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./m-menu.vue?vue&type=style&index=0&id=ebcb8ac8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebcb8ac8",
  null
  
)

export default component.exports